import BankAccountDTO from "../../domain/Registration/BankAccountDTO";
import WsService from "../WsService";

export default class AdminBankAccountService {

  static retrieveActiveBankAccount(registrationId) {

    let endpoint = "/admin/registration/" + registrationId + "/bank-account/active";

    return WsService.get(endpoint, {}, 200).then(
      response => {
        return new BankAccountDTO(response);
      },
      response => {
        return response;
      });
  }
}
